// The forest icon set; its own module so light pages and unit tests can draw icons without loading app-core.
export type ForestIconName =
  | "classroom" | "stopwatch" | "students" | "journal" | "palette"
  | "settings" | "classes" | "teacher" | "sprout" | "group"
  | "checklist" | "calendar" | "star" | "heart" | "check"
  | "undo" | "raise-hand" | "help" | "cooperate" | "homework"
  | "focus" | "tidy" | "challenge" | "speak" | "picker"
  | "hourglass" | "instruction" | "shuffle" | "paw" | "hatch"
  | "search" | "export" | "storybook" | "shield" | "question"
  | "scroll" | "lantern" | "path" | "signpost" | "bell"
  | "acorn" | "celebrate" | "leaf-calendar" | "blackboard"
  | "tree-rings" | "pencil-leaf" | "community" | "sunrise"
  | "coin" | "poll" | "roll-call" | "duty" | "gift";

export function ForestIcon({ name, className = "" }: { name: ForestIconName; className?: string }) {
  const base = `/assets/optimized/v1/forest-ui/icons/${name}`;
  return <img className={`forest-icon ${className}`} src={`${base}.webp`} srcSet={`${base}-96.webp 1x, ${base}-192.webp 2x, ${base}.webp 3x`} alt="" aria-hidden="true" />;
}
